// removed by extract-text-webpack-plugin
module.exports = {"logInButton":"logInButton--2WGyA"};